module.exports = __webpack_public_path__ + "static/food-detection-592925db72fc27c5ab558ce37d893729.mp4";